<div>
    <form nz-form #worklogPage="ngForm">
        <div nz-row nzGutter="5">
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Start Date Time</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker style="width: 100%;" name="updatedDate" nzShowTime
                            [nzDisabledDate]="disabledStartDate" [nzShowTime]="{ nzFormat: 'hh:mm a' }"
                            nzFormat="dd/MM/yyyy hh:mm a" [(ngModel)]="data.WORKED_DATETIME"
                            (nzOnOpenChange)="moduleStartDateHandle($event)" (ngModelChange)="startDateChange()">
                        </nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>End Date Time</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker #moduleEndDatePicker style="width: 100%;" name="endDate" nzShowTime
                            [nzDisabledDate]="disabledEndDate" [nzShowTime]="{ nzFormat: 'hh:mm a' }"
                            nzFormat="dd/MM/yyyy hh:mm a" [(ngModel)]="data.END_DATETIME"
                            (nzOnOpenChange)="moduleEndDateHandle($event)" (ngModelChange)="endDateChange()">
                        </nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzNoColon>Time Spent</nz-form-label>

                    <nz-form-control>
                        <b><span>{{data.SPENT_HOURS}}h {{data.SPENT_MINUTES}}m {{data.SPENT_SECONDS}}s</span></b>
                    </nz-form-control>

                    <!-- <div style="display: inline-flex;">
                        <nz-form-control nzErrorTip="Hours is Required">
                            <input nz-input name="spentHours" type="number" min="0"
                                oninput="this.value = Math.abs(this.value)" placeHolder="HH"
                                [(ngModel)]="data.SPENT_HOURS" required />
                        </nz-form-control>

                        <nz-form-control nzErrorTip="Minutes is Required">
                            <input nz-input name="spentMinutes" type="number" min="0"
                                oninput="this.value = Math.abs(this.value)" placeHolder="MM"
                                [(ngModel)]="data.SPENT_MINUTES" required />
                        </nz-form-control>

                        <nz-form-control nzErrorTip="Seconds is Required">
                            <input nz-input name="spentSeconds" type="number" min="0"
                                oninput="this.value = Math.abs(this.value)" placeHolder="SS"
                                [(ngModel)]="data.SPENT_SECONDS" required />
                        </nz-form-control>
                    </div> -->
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12" *ngIf="estimatedTime_Mandays== 'T'">
                <nz-form-item>
                    <nz-form-label nzNoColon>Estimated Time</nz-form-label>

                    <nz-form-control>
                        <b><span>{{estimatedHH}}h {{estimatedMM}}m {{estimatedSS}}s</span></b>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12" *ngIf="estimatedTime_Mandays== 'M'">
                <nz-form-item>
                    <nz-form-label nzNoColon>Estimated Mandays</nz-form-label>

                    <nz-form-control>
                        <b><span>{{estimatedMandays}}</span></b>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Description</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Work Description is Required">
                        <textarea nz-input rows="4" name="workDescription" placeHolder="Enter a Work Description"
                            [(ngModel)]="data.WORK_DESCRIPTION" maxlength="500" required></textarea>
                    </nz-form-control>

                    <span *ngIf="data.WORK_DESCRIPTION"
                        style="font-size: 10px; color: red;">{{data.WORK_DESCRIPTION.length}}/ 500</span>
                </nz-form-item>
            </div>

            <!-- <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Active</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isActive" [(ngModel)]="data.IS_ACTIVE"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Type</nz-form-label>

                    <nz-form-control>
                        <input nz-input name="type" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.TYPE" required/>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Type ID</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Spent Seconds is Required">
                        <input nz-input name="typeID" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.TYPE_ID" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close(worklogPage)"><span>Cancel</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false, worklogPage)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-dropdown [nzDropdownMenu]="menu" *ngIf="!data.ID" nz-button
        [nzLoading]="isSpinning" (click)="save(false, worklogPage)"><span>Save & Close</span></button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                <a (click)="save(true, worklogPage)">Save & New</a>
            </li>
        </ul>
    </nz-dropdown-menu>

    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;" (click)="resetDrawer(worklogPage)"><span>Reset</span></button> -->
</div>